import { getColIdxFromClientX, createImageElement, deleteImage, refreshImagePosition, completeAction, readonlyAlert } from '../common/event';
import { insertImage, refreshImgCellObj, getRowIdxFromClientY } from '../common/event';
import { overlay, dialog } from '../common/index';
import { isUndefined, getUniqueID, isNullOrUndefined } from '@syncfusion/ej2-base';
import { getCell, setCell, getSheetIndex, getRowsHeight, getColumnsWidth, beginAction, getCellAddress, getSheet, isReadOnlyCells, getRangeAddress, addDPRValue } from '../../workbook/index';
import { getRangeIndexes, setImage } from '../../workbook/index';
export class SpreadsheetImage {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
        this.renderImageUpload();
    }
    /**
     * Adding event listener for success and failure
     *
     * @returns {void} - Adding event listener for success and failure
     */
    addEventListener() {
        this.parent.on(insertImage, this.insertImage, this);
        this.parent.on(refreshImgCellObj, this.refreshImgCellObj, this);
        this.parent.on(createImageElement, this.createImageElement, this);
        this.parent.on(deleteImage, this.deleteImage, this);
        this.parent.on(refreshImagePosition, this.refreshInsDelImagePosition, this);
    }
    /**
     * Rendering upload component for importing images.
     *
     * @returns {void} - Rendering upload component for importing images.
     */
    renderImageUpload() {
        const uploadBox = this.parent.createElement('input', {
            id: this.parent.element.id + '_imageUpload',
            attrs: { type: 'file', accept: '.image, .jpg, .png, .gif ,jpeg', name: 'fileUpload' }
        });
        uploadBox.style.display = 'none';
        this.parent.element.appendChild(uploadBox);
        uploadBox.onchange = this.imageSelect.bind(this);
    }
    /**
     * Process after select the excel and image file.
     *
     * @param {Event} args - File select native event.
     * @returns {void} - Process after select the excel and image file.
     */
    imageSelect(args) {
        const file = args.target.files[0];
        if (!file) {
            return;
        }
        if (file.type.includes('image')) {
            this.insertImage({ file: file, isAction: true });
        }
        else {
            this.parent.serviceLocator.getService(dialog).show({ content: this.parent.serviceLocator.getService('spreadsheetLocale').getConstant('UnsupportedFile'),
                width: '300' });
        }
        args.target.value = '';
    }
    /**
     * Removing event listener for success and failure
     *
     * @returns {void} - Removing event listener for success and failure
     */
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(insertImage, this.insertImage);
            this.parent.off(refreshImgCellObj, this.refreshImgCellObj);
            this.parent.off(createImageElement, this.createImageElement);
            this.parent.off(deleteImage, this.deleteImage);
            this.parent.off(refreshImagePosition, this.refreshInsDelImagePosition);
        }
    }
    /* eslint-disable */
    insertImage(args, range) {
        this.binaryStringVal(args).then(src => {
            const imageData = (typeof src === "string" || src instanceof ArrayBuffer) ? { dataUrl: src } : src;
            this.createImageElement({ options: { src: imageData.dataUrl, height: imageData.height, width: imageData.width }, range: range, isPublic: true, isAction: args.isAction });
        });
    }
    binaryStringVal(args) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(args.file);
            reader.onload = () => {
                const img = new Image();
                img.onload = () => resolve({ dataUrl: reader.result, width: img.width, height: img.height });
                img.onerror = reject;
                img.src = reader.result;
            };
            reader.onerror = error => reject(error);
        });
    }
    /* eslint-enable */
    createImageElement(args) {
        const lastIndex = args.range ? args.range.lastIndexOf('!') : 0;
        let range = args.range ? (lastIndex > 0) ? args.range.substring(lastIndex + 1) : args.range
            : this.parent.getActiveSheet().selectedRange;
        const sheetIndex = (args.range && lastIndex > 0) ?
            getSheetIndex(this.parent, args.range.substring(0, lastIndex)) : this.parent.activeSheetIndex;
        const overlayObj = this.parent.serviceLocator.getService(overlay);
        const id = args.options.id ? args.options.id : getUniqueID(this.parent.element.id + '_overlay_picture_');
        const indexes = getRangeIndexes(range);
        const sheet = isUndefined(sheetIndex) && !args.isUndoRedo ? this.parent.getActiveSheet() :
            this.parent.sheets[sheetIndex];
        const panel = this.parent.getMainContent() || this.parent.element;
        if (!sheet || panel.querySelector(`#${id}`) ||
            ((sheet.frozenRows || sheet.frozenColumns) && this.parent.element.querySelector(`#${id}`))) {
            return;
        }
        if (args.isPublic && isReadOnlyCells(this.parent, indexes)) {
            if (args.isAction) {
                this.parent.notify(readonlyAlert, null);
            }
            return;
        }
        let eventArgs = { requestType: 'beforeInsertImage', range: sheet.name + '!' + range, imageData: args.options.src,
            sheetIndex: sheetIndex };
        if (args.isPublic) {
            this.parent.notify('actionBegin', { eventArgs: eventArgs, action: 'beforeInsertImage' });
        }
        if (eventArgs.cancel) {
            return;
        }
        let overlayProps = overlayObj.insertOverlayElement(id, range, sheetIndex);
        overlayProps.element.style.backgroundImage = 'url(\'' + args.options.src + '\')';
        const isFreezePane = sheet.frozenRows || sheet.frozenColumns;
        const setTopLeftPosition = () => {
            if (!isNullOrUndefined(args.options.top)) {
                overlayProps.element.style.top = Number(((!isFreezePane && args.options.preservePos && overlayProps.top) ?
                    overlayProps.dprTop + addDPRValue(Math.abs(args.options.top - overlayProps.top)) :
                    addDPRValue(args.options.top)).toFixed(2)) + 'px';
            }
            if (!isNullOrUndefined(args.options.left)) {
                overlayProps.element.style.left = Number(addDPRValue((!isFreezePane && args.options.preservePos && overlayProps.left > args.options.left) ? overlayProps.left :
                    args.options.left).toFixed(2)) + 'px';
            }
        };
        if (args.options.height || args.options.left) {
            overlayProps.element.style.height = args.options.height + 'px';
            overlayProps.element.style.width = args.options.width + 'px';
            setTopLeftPosition();
            if (!args.options.preservePos && !isNullOrUndefined(args.options.top) && !isNullOrUndefined(args.options.left)) {
                const imgTop = { clientY: args.options.top, isImage: true };
                const imgleft = { clientX: args.options.left, isImage: true };
                this.parent.notify(getRowIdxFromClientY, imgTop);
                this.parent.notify(getColIdxFromClientX, imgleft);
                const rowIdx = imgTop.clientY;
                const colIdx = imgleft.clientX;
                if (indexes[0] !== rowIdx || indexes[1] !== colIdx) {
                    const eventArgs = {
                        prevTop: args.options.top, prevLeft: args.options.left, prevRowIdx: indexes[0],
                        prevColIdx: indexes[1], prevHeight: args.options.height, prevWidth: args.options.width,
                        currentTop: args.options.top, currentLeft: args.options.left, currentRowIdx: rowIdx,
                        currentColIdx: colIdx, currentHeight: args.options.height, currentWidth: args.options.width,
                        id: args.options.id, requestType: 'imagePositionRefresh'
                    };
                    this.refreshImgCellObj(eventArgs);
                    indexes[0] = rowIdx;
                    indexes[1] = colIdx;
                    range = getRangeAddress([rowIdx, colIdx]);
                }
            }
        }
        if (isFreezePane) {
            overlayObj.adjustFreezePaneSize(args.options, overlayProps.element, range);
        }
        const imgData = {
            src: args.options.src, id: id, height: parseFloat(overlayProps.element.style.height.replace('px', '')),
            width: parseFloat(overlayProps.element.style.width.replace('px', '')),
            top: isFreezePane ? (indexes[0] ? getRowsHeight(sheet, 0, indexes[0] - 1) : 0) :
                (isNullOrUndefined(args.options.top) || (args.options.preservePos && overlayProps.top > args.options.top) ?
                    overlayProps.top : args.options.top),
            left: isFreezePane ? (indexes[1] ? getColumnsWidth(sheet, 0, indexes[1] - 1) : 0) :
                (isNullOrUndefined(args.options.left) || (args.options.preservePos && overlayProps.left > args.options.left) ?
                    overlayProps.left : args.options.left),
            preservePos: args.options.preservePos
        };
        this.parent.setUsedRange(indexes[0], indexes[1]);
        let isPositionChanged = false;
        const isElementRemoved = false;
        if (!args.isPublic && !args.isUndoRedo && (imgData.top !== args.options.top || imgData.left !== args.options.left)) {
            args.options.top = imgData.top;
            args.options.left = imgData.left;
            isPositionChanged = true;
        }
        const setImageEventArgs = {
            options: [imgData], range: sheet.name + '!' + range, isPositionChanged: isPositionChanged, isElementRemoved
        };
        if (args.isPublic || args.isUndoRedo || isPositionChanged) {
            this.parent.notify(setImage, setImageEventArgs);
        }
        if (isPositionChanged && setImageEventArgs.isElementRemoved) {
            overlayProps = overlayObj.insertOverlayElement(id, range, sheetIndex);
            overlayProps.element.style.backgroundImage = 'url(\'' + args.options.src + '\')';
            if (args.options.height && args.options.width) {
                overlayProps.element.style.height = args.options.height + 'px';
                overlayProps.element.style.width = args.options.width + 'px';
            }
            setTopLeftPosition();
        }
        const currCell = getCell(indexes[0], indexes[1], sheet);
        for (let i = 0; i < currCell.image.length; i++) {
            const image = currCell.image[i];
            if (!image.id) {
                image.id = imgData.id;
                break;
            }
        }
        if (!args.isUndoRedo && args.isPublic) {
            eventArgs = { requestType: 'insertImage', range: sheet.name + '!' + range, imageHeight: args.options.height ?
                    args.options.height : 300, imageWidth: args.options.width ? args.options.width : 400, imageData: args.options.src, id: id,
                sheetIndex: sheetIndex };
            this.parent.notify('actionComplete', { eventArgs: eventArgs, action: 'insertImage' });
        }
    }
    refreshInsDelImagePosition(args) {
        const count = args.count;
        const sheetIdx = args.sheetIdx;
        const sheet = this.parent.sheets[sheetIdx];
        let pictureElements;
        const currCellObj = getCell(args.rowIdx, args.colIdx, sheet);
        const imageLen = currCellObj.image.length;
        let top;
        let left;
        for (let i = 0; i < imageLen; i++) {
            pictureElements = document.getElementById(currCellObj.image[i].id);
            top = (args.type === 'Row') ? (args.status === 'insert') ? currCellObj.image[i].top + (count * 20) :
                currCellObj.image[i].top - (count * 20) : currCellObj.image[i].top;
            left = (args.type === 'Column') ? (args.status === 'insert') ? currCellObj.image[i].left + (count * 64) :
                currCellObj.image[i].left - (count * 64) : currCellObj.image[i].left;
            currCellObj.image[i].top = top;
            currCellObj.image[i].left = left;
            if (pictureElements) {
                pictureElements.style.top = top + 'px';
                pictureElements.style.left = left + 'px';
            }
        }
    }
    refreshImgCellObj(args) {
        const sheetIndex = isUndefined(args.sheetIdx) ? this.parent.activeSheetIndex : args.sheetIdx;
        const sheet = getSheet(this.parent, sheetIndex);
        const prevCellObj = getCell(args.prevRowIdx, args.prevColIdx, sheet);
        const currCellObj = getCell(args.currentRowIdx, args.currentColIdx, sheet);
        const prevCellImg = prevCellObj ? prevCellObj.image : [];
        let prevImgObj;
        let currImgObj;
        const prevCellImgLen = (prevCellImg && prevCellImg.length) ? prevCellImg.length : 0;
        if (prevCellObj && prevCellObj.image && prevCellImg.length > 0) {
            for (let i = 0; i < prevCellImgLen; i++) {
                if (prevCellImg[i] && prevCellImg[i].id === args.id) {
                    prevImgObj = prevCellImg[i];
                    prevImgObj.height = args.currentHeight;
                    prevImgObj.width = args.currentWidth;
                    prevImgObj.top = args.currentTop;
                    prevImgObj.left = args.currentLeft;
                    prevCellImg.splice(i, 1);
                }
            }
            if (currCellObj && currCellObj.image) {
                currImgObj = currCellObj.image;
                if (prevImgObj) {
                    currImgObj.push(prevImgObj);
                }
            }
            if (currImgObj) {
                setCell(args.currentRowIdx, args.currentColIdx, sheet, { image: currImgObj }, true);
            }
            else {
                setCell(args.currentRowIdx, args.currentColIdx, sheet, { image: [prevImgObj] }, true);
            }
            const extendedSheet = sheet;
            if (extendedSheet.imageColl) {
                let img;
                for (img of extendedSheet.imageColl) {
                    if (img.id === prevImgObj.id) {
                        img.address = [args.currentRowIdx, args.currentColIdx];
                        break;
                    }
                }
            }
            if (args.requestType === 'imageRefresh' && !args.isUndoRedo) {
                const eventArgs = {
                    requestType: 'imageRefresh', currentRowIdx: args.currentRowIdx, currentColIdx: args.currentColIdx,
                    prevRowIdx: args.prevRowIdx, prevColIdx: args.prevColIdx, prevTop: args.prevTop, prevLeft: args.prevLeft,
                    currentTop: args.currentTop, currentLeft: args.currentLeft, currentHeight: args.currentHeight,
                    currentWidth: args.currentWidth, prevHeight: args.prevHeight, prevWidth: args.prevWidth,
                    id: args.id, sheetIdx: this.parent.activeSheetIndex
                };
                this.parent.notify('actionComplete', { eventArgs: eventArgs, action: 'imageRefresh' });
            }
        }
    }
    deleteImage(args) {
        let sheet = args.sheet || this.parent.getActiveSheet();
        const pictureElements = document.getElementById(args.id);
        let rowIdx = args.rowIdx;
        let colIdx = args.colIdx;
        let address;
        if (pictureElements) {
            if (args.rowIdx === undefined && args.colIdx === undefined) {
                let imgTop;
                let imgleft;
                if (sheet.frozenRows || sheet.frozenColumns) {
                    const clientRect = pictureElements.getBoundingClientRect();
                    imgTop = { clientY: clientRect.top };
                    imgleft = { clientX: clientRect.left };
                    if (clientRect.top < this.parent.getColumnHeaderContent().getBoundingClientRect().bottom) {
                        imgTop.target = this.parent.getColumnHeaderContent();
                    }
                    if (clientRect.left < this.parent.getRowHeaderContent().getBoundingClientRect().right) {
                        imgleft.target = this.parent.getRowHeaderTable();
                    }
                }
                else {
                    imgTop = { clientY: parseFloat(pictureElements.style.top), isImage: true };
                    imgleft = { clientX: parseFloat(pictureElements.style.left), isImage: true };
                }
                this.parent.notify(getRowIdxFromClientY, imgTop);
                this.parent.notify(getColIdxFromClientX, imgleft);
                rowIdx = imgTop.clientY;
                colIdx = imgleft.clientX;
            }
            address = sheet.name + '!' + getCellAddress(rowIdx, colIdx);
            if (!args.preventEventTrigger) {
                const eventArgs = { address: address, cancel: false };
                this.parent.notify(beginAction, { action: 'deleteImage', eventArgs: eventArgs });
                if (eventArgs.cancel) {
                    return;
                }
            }
            document.getElementById(args.id).remove();
        }
        else if (!args.sheet) {
            const rangeVal = args.range ? args.range.lastIndexOf('!') > 0 ? args.range.substring(args.range.lastIndexOf('!') + 1)
                : args.range : this.parent.getActiveSheet().selectedRange;
            const sheetIndex = args.range && args.range.lastIndexOf('!') > 0 ?
                getSheetIndex(this.parent, args.range.substring(0, args.range.lastIndexOf('!'))) :
                this.parent.activeSheetIndex;
            const index = getRangeIndexes(rangeVal);
            rowIdx = index[0];
            colIdx = index[1];
            sheet = this.parent.sheets[sheetIndex];
        }
        let image = {};
        if (sheet) {
            const cellObj = getCell(rowIdx, colIdx, sheet);
            const prevCellImg = (cellObj && cellObj.image) ? cellObj.image : [];
            const imgLength = prevCellImg.length;
            for (let i = imgLength - 1; i >= 0; i--) {
                if (prevCellImg[i].id === args.id) {
                    image = prevCellImg.splice(i, 1)[0];
                }
            }
            setCell(rowIdx, colIdx, sheet, { image: prevCellImg }, true);
        }
        if (!args.preventEventTrigger) {
            this.parent.notify(completeAction, { action: 'deleteImage', eventArgs: { address: address, id: image.id, imageData: image.src, imageWidth: image.width,
                    imageHeight: image.height, imageTop: image.top, imageLeft: image.left, preservePos: image.preservePos, cancel: false },
                preventAction: args.isUndoRedo, isClearAction: args.clearAction
            });
        }
    }
    /**
     * To Remove the event listeners.
     *
     * @returns {void} - To Remove the event listeners.
     */
    destroy() {
        this.removeEventListener();
        this.parent = null;
    }
    /**
     * Get the sheet picture module name.
     *
     * @returns {string} - Get the sheet picture module name.
     */
    getModuleName() {
        return 'spreadsheetImage';
    }
}
